// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
export const Icon = function Icon(_a) {
    var { ref, name, size = 15, className } = _a, rest = __rest(_a, ["ref", "name", "size", "className"]);
    return (_jsx("svg", Object.assign({ ref: ref, className: classNames('flex-shrink-0 layer-components:fill-none', className), width: size, height: size }, rest, { children: _jsx("use", { xlinkHref: `#icon-${name}` }) })));
};
//# sourceMappingURL=Icon.js.map